<template>
  <div>
    {{ desc }}

    <template v-if="useBufferedWords">
      <i
        v-if="!editnow"
        @click="startEdit"
        class="cursor-pointer ml-2 icon-pencil text-primary"
      ></i>
      <i
        v-if="editnow"
        class="icon-close text-danger ml-1 cursor-pointer"
        @click="cancelEdit"
      ></i>
      <span
        class="ml-4"
        v-if="type == 'targetKeyword'"
        v-bind:class="
          internalWords.split(',').length > 100
            ? 'text-danger font-weight-bold'
            : 'text-success'
        "
      >
        Total Keywords {{ internalWords.split(",").length }}</span
      >
      <div
        v-if="!editnow && internalWords && type != 'opneaiprompts'"
        style="max-height:200px;overflow:scroll"
      >
        <small
          v-for="(word, idx) in internalWords.split(',')"
          :key="'w-' + idx + '-' + word"
          class="text-lowercase bg-secondary text-white mx-1 "
        >
          |{{ word }}|
        </small>
      </div>
      <div
        v-if="!editnow && internalWords && type == 'opneaiprompts'"
        style="max-height:200px;overflow:scroll"
      >
        <small class="mx-1 ">
          {{ internalWords }}
        </small>
      </div>
      <div class="bg-light p-3" v-if="editnow">
        <textarea type="text" class="form-control" v-model="internalWords" rows="5">
        </textarea>
        <button @click="updateWords()" class="btn btn-sm btn-primary mt-2">
          {{ $t("lang.button.save") }}
        </button>
      </div>
    </template>

    <template v-else>
      <i
        v-if="!editnow"
        @click="editnow = true"
        class="cursor-pointer ml-2 icon-pencil text-primary"
      ></i>
      <i
        v-if="editnow"
        class="icon-close text-danger ml-1 cursor-pointer"
        @click="editnow = false"
      ></i>
      <span
        class="ml-4"
        v-if="type == 'targetKeyword'"
        v-bind:class="
          words.split(',').length > 100
            ? 'text-danger font-weight-bold'
            : 'text-success'
        "
      >
        Total Keywords {{ words.split(",").length }}</span
      >
      <div
        v-if="!editnow && words && type != 'opneaiprompts'"
        style="max-height:200px;overflow:scroll"
      >
        <small
          v-for="(word, idx) in words.split(',')"
          :key="'w-' + idx + '-' + word"
          class="text-lowercase bg-secondary text-white mx-1 "
        >
          |{{ word }}|
        </small>
      </div>
      <div
        v-if="!editnow && words && type == 'opneaiprompts'"
        style="max-height:200px;overflow:scroll"
      >
        <small class="mx-1 ">
          {{ words }}
        </small>
      </div>
      <div class="bg-light p-3" v-if="editnow">
        <textarea type="text" class="form-control" v-model="words" rows="5">
        </textarea>
        <button @click="updateWords()" class="btn btn-sm btn-primary mt-2">
          {{ $t("lang.button.save") }}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import {
  adminService,
  targetSequencesService,
  targetsService
} from "@/_services";
import Fieldset from "@/components/Common/Fieldset.vue";

export default {
  components: {
    Fieldset
  },

  data() {
    return {
      editnow: false,
      internalWords: ""
    };
  },
  props: {
    desc: false,
    type: false,
    words: false,
    id: false,
    /** When true, keeps a local copy of `words` so parents can pass derived strings (e.g. from API maps) without breaking edit/save. Default preserves legacy behaviour. */
    useBufferedWords: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    words: {
      immediate: true,
      handler() {
        if (!this.useBufferedWords || this.editnow) {
          return;
        }
        this.syncInternalFromProp();
      }
    }
  },

  methods: {
    syncInternalFromProp() {
      const val = this.words;
      this.internalWords =
        val === false || val === null || val === undefined ? "" : String(val);
    },
    startEdit() {
      this.syncInternalFromProp();
      this.editnow = true;
    },
    cancelEdit() {
      this.editnow = false;
      this.syncInternalFromProp();
    },
    currentPayload() {
      return this.useBufferedWords ? this.internalWords : this.words;
    },
    updateWords() {
      const payload = this.currentPayload();
      if (this.type == "opneaiprompts") {
        targetSequencesService
          .savePromptSequenceType(this.id, payload)
          .then(response => {
            this.editnow = false;
          });
      } else {
        if (this.type == "targetKeyword") {
          if (payload.split(",").length < 101) {
            targetsService
              .updateJobWords({ id: this.id, words: payload })
              .then(res => {
                if (res) {
                  this.$swal({
                    type: "success",
                    title: "Update Words",
                    text: this.$t("lang.label.datasavedsuccessfully"),
                    showConfirmButton: false,
                    timer: 2000
                  });
                }
                this.editnow = false;

                this.$emit("update", { id: this.id, words: payload });
              });
          } else {
            this.$swal({
              type: "error",
              title: "Max Words",
              text: "max words should be 100",
              showConfirmButton: false,
              timer: 2000
            });
          }
        } else {
          // console.log("type", this.type)
          // console.log('payload', payload)
          
          adminService
            .updateOliverVariables(payload, this.type)
            .then(response => {
              this.editnow = false;
              this.$emit('saved');
            });
        }
      }
    }
  }
};
</script>
